<template>
    <el-config-provider :locale="locale">
        <router-view v-slot="{ Component }">
            <component :is="Component" />
        </router-view>
    </el-config-provider>
    <subAd v-if="showSubAd"/>
</template>
<script>
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import { ElConfigProvider } from 'element-plus';
import subAd from './components/ProShop/subAd.vue';
export default {
    components: {
        ElConfigProvider,
        subAd
    },
    data() {
        return {
            locale: zhCn,
            showSubAd: false,
        };
    },
    watch: {
        '$route': {
            handler(to, from) {
                this.showSubAd = !['/qwClientDetail'].includes(to.path)
            },
            immediate: true     
        },
    },
    methods: {
        
    },
};
</script>
<style lang="scss">
#app{
    height: 100%;
}

</style>
